import { configureStore } from '@reduxjs/toolkit';

import formStateReducer from '../features/formStateSlice';
import timeLineReducer from '../features/timeLineSlice';

export const store = configureStore({
	reducer: {
		timeLine: timeLineReducer,
		formState: formStateReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;
